import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { TwirlDown } from "../../controls/TwirlDown";
import { LibraryThing } from "../../widget/LibraryThingWidget";
import { BaseDetailView } from "./BaseDetailView";

export class Titles_LookInside extends BaseDetailView {
  constructor(options) {
    options = options || {};

    options.id = LS2PAC_CONSTANTS.Ids.DetailsPage.lookInsideContainer;
    options.resultsTemplate = "tmpl/details/titles_lookInside.html";

    super(options);

    this.sections = [];
  }
  destroy() {
    for (var i = 0, len = this.sections.length; i < len; i++) {
      var twirlDown = this.sections[i].twirlDown;
      twirlDown.destroy();
      this.sections[i].twirlDown = null;
    }
    this.sections = [];
  }
  load(resourceData, index, headerText) {
    var target = $("#" + this.id);
    this.destroy(); // destroy old enrichments
    var enrichments = [
      LibraryThing.enums.enrichments.summary,
      LibraryThing.enums.enrichments.videoGameSummary,
      LibraryThing.enums.enrichments.videoAndMusicSummary,
      LibraryThing.enums.enrichments.awards,
      LibraryThing.enums.enrichments.lookInside,
      LibraryThing.enums.enrichments.bookProfile,
      LibraryThing.enums.enrichments.aboutTheAuthor,
    ];

    var len = enrichments.length;
    var loaded = 0;
    var metaData = this.currentResource;
    var _this = this;
    var selector = "#" + this.id;

    for (var i = 0; i < len; i++) {
      var enrichment = enrichments[i];
      var twirlDown = new TwirlDown(enrichment.className, enrichment.label);
      twirlDown.init(
        target,
        (function (twirlDown, enrichment) {
          return function () {
            twirlDown.hide();
            var targetContainer = twirlDown.getContentContainer();
            LibraryThing.addEnrichment(targetContainer, enrichment);
            loaded++;
            if (len === loaded) {
              _this.refreshSUMetaData(
                selector,
                metaData,
                function (enrichmentsShown) {
                  _this.onLoadEnrichments(enrichmentsShown);
                }
              );
            }
          };
        })(twirlDown, enrichment)
      );
      this.sections.push({
        enrichment: enrichment,
        twirlDown: twirlDown,
      });
    }
  }
  onLoadEnrichments(enrichmentsShown) {
    this.sections.forEach(function (section) {
      if (enrichmentsShown.indexOf(section.enrichment.name) !== -1) {
        section.twirlDown.show();
        section.twirlDown.open();
      }
    });
  }
}
